import { getATLContextDomain, isFedRamp } from '@atlassian/atl-context';
import { ff } from '@atlassian/jira-feature-flagging';

export const LOAD_START_MARK_KEY = 'PROJECT_CONFIGURE_MAIL_SERVER_MODAL_LOAD_START_MARK_KEY';

// Data-test-ids
export const DELETE_SERVER_MODAL_CLOSE_BUTTON =
	'configure-mailserver-modal.ui.delete-mailserver-modal.modal-footer.close-button';

export const DELETE_SERVER_MODAL_DELETE_BUTTON =
	'configure-mailserver-modal.ui.delete-mailserver-modal.modal-footer.delete-button';

export const DELETE_SERVER_MODAL_SUCCESS_FLAG =
	'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-success';

export const DELETE_SERVER_MODAL_FAILURE_FLAG =
	'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-failure';

export const OAUTH_UPDATE_MAIL_SERVER_SAVE_BUTTON =
	'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.save-button';

export const OAUTH_UPDATE_MAIL_SERVER_CANCEL_BUTTON =
	'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.cancel-button';

export const OAUTH_UPDATE_MAIL_SERVER_REAUTHORIZE_BUTTON =
	'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.reauthorize-button';

export const OAUTH_SERVER_MODAL_SUCCESS_FLAG =
	'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';

export const OAUTH_SERVER_MODAL_ERROR_FLAG =
	'configure-mailserver-modal.ui.basic-details-modal.flags.create-failure';

export const OAUTH_UPDATE_SERVER_MODAL_SUCCESS_FLAG =
	'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-success';

export const OAUTH__UPDATE_SERVER_MODAL_ERROR_FLAG =
	'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-failure';

export const OAUTH_SAVE_AND_REAUTHORIZE_SERVER_MODAL_SUCCESS_FLAG =
	'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-success';

export const OAUTH__SAVE_AND_REAUTHORIZE_SERVER_MODAL_ERROR_FLAG =
	'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-failure';

export const CUSTOM_MAIL_SERVER_SUBMIT_BUTTON =
	'configure-mail-server-modal.ui.custom-mailserver-modal.modal-footer.submit';

export const CUSTOM_SERVER_MODAL_SUCCESS_FLAG =
	'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';

export const CUSTOM_SERVER_MODAL_ERROR_FLAG =
	'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-failure';

export const SAVE_AND_REAUTHORIZE_SUBMIT_BUTTON =
	'configure-mailserver-modal.ui.update-oauth-mailserver-modal.save-and-reauthorize-modal.modal-footer.save-and-reauthorize-button';
export const SAVE_AND_REAUTHORIZE_CANCEL_BUTTON =
	'configure-mailserver-modal.ui.update-oauth-mailserver-modal.save-and-reauthorize-modal.modal-footer.close-button';

export const CUSTOM_SERVER_MODAL_INLINE_ERROR_MESSAGE =
	'configure-mail-server-modal.custom-mailserver-modal.inline-error';

// Analytics
export const EDIT_MAIL_SERVER_MODAL = 'editMailServer';
export const ADD_MAIL_SERVER_MODAL = 'addMailServer';
export const EDIT_CUSTOM_MAIL_SERVER_MODAL = 'editCustomMailServer';
export const EDIT_OAUTH_MAIL_SERVER_MODAL = 'editOAUTHMailServer';
export const ADD_CUSTOM_MAIL_SERVER_MODAL = 'addCustomMailServer';
export const DELETE_MAIL_SERVER_MODAL = 'deleteMailServer';
export const SAVE_AND_REAUTHORIZE_MAIL_SERVER_MODAL = 'saveChanges';
export const BASIC_DETAILS_MAIL_SERVER_SAVE_BTN = 'saveMailServerButton';
export const BASIC_DETAILS_MAIL_SERVER_CANCEL_BTN = 'cancelSaveMailServerButton';
export const SAVE_AND_REAUTHORIZE_MAIL_SERVER_SUBMIT_BTN = 'saveMailServerButton';
export const SAVE_AND_REAUTHORIZE_MAIL_SERVER_CANCEL_BTN = 'cancelSaveMailServerButton';
export const DELETE_SERVER_SUBMIT_BTN = 'confirmDeleteMailServerButton';
export const DELETE_SERVER_CANCEL_BTN = 'cancelDeleteMailServerButton';
export const CUSTOM_DETAILS_MAIL_SERVER_SAVE_BTN = 'saveCustomMailServerButton';
export const CUSTOM_DETAILS_MAIL_SERVER_CANCEL_BTN = 'cancelSaveCustomMailServerButton';

export const GMAIL_SERVICE_KEY = 'jira-email-service-gmail';
export const MICROSOFT_SERVICE_KEY = 'jira-email-service-microsoft';

// Values for the threeLOUrl key are taken from
// https://developer.atlassian.com/platform/outbound-auth/guides/environments/
// The above also explains why dev and staging use identical information.
// Values for serviceKey and containerId are taken from
// https://hello.atlassian.net/wiki/spaces/VPORT/pages/654247405/JSD+3LO+3rd+party+configuration+links+Google+Microsoft
export const getOAuth3LOProvider = () => {
	if (isFedRamp()) {
		return {
			[MICROSOFT_SERVICE_KEY]: {
				prod: {
					containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
					threeLOUrl: `https://${getATLContextDomain('id', ['prod', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				staging: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				dev: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				local: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['dev', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
			},
			[GMAIL_SERVICE_KEY]: {
				prod: {
					containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
					threeLOUrl: `https://${getATLContextDomain('id', ['prod', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				staging: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				dev: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
				local: {
					containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
					threeLOUrl: `https://${getATLContextDomain('id', ['dev', 'fedramp-moderate'])}/outboundAuth/v2/start`,
				},
			},
		} as const;
	}

	return {
		[MICROSOFT_SERVICE_KEY]: {
			prod: {
				containerId: ff('microsoft-outbound-auth-url-change_2njeh')
					? '4236689d-d21d-4741-ab4f-71892b2d55f9'
					: 'c16a389e-0776-44b3-9528-19c82119a022',
				threeLOUrl: `https://${getATLContextDomain('id')}/outboundAuth/v2/start`,
			},
			staging: {
				containerId: ff('microsoft-outbound-auth-url-change_2njeh')
					? 'e1b53a56-0a21-419e-a258-ee1d435ea0b8'
					: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'commercial'])}/outboundAuth/v2/start`,
			},
			dev: {
				containerId: ff('microsoft-outbound-auth-url-change_2njeh')
					? 'e1b53a56-0a21-419e-a258-ee1d435ea0b8'
					: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'commercial'])}/outboundAuth/v2/start`,
			},
			local: {
				containerId: ff('microsoft-outbound-auth-url-change_2njeh')
					? 'e1b53a56-0a21-419e-a258-ee1d435ea0b8'
					: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['dev', 'commercial'])}/outboundAuth/v2/start`,
			},
		},
		[GMAIL_SERVICE_KEY]: {
			prod: {
				containerId: 'c16a389e-0776-44b3-9528-19c82119a022',
				threeLOUrl: `https://${getATLContextDomain('id')}/outboundAuth/v2/start`,
			},
			staging: {
				containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'commercial'])}/outboundAuth/v2/start`,
			},
			dev: {
				containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['stg', 'commercial'])}/outboundAuth/v2/start`,
			},
			local: {
				containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
				threeLOUrl: `https://${getATLContextDomain('id', ['dev', 'commercial'])}/outboundAuth/v2/start`,
			},
		},
	} as const;
};
